export enum ClientOrganizationTypeEnum
{
  General = 0,
  EPS = 1,
  CYA = 2
}